<template>
    <div class="view--loans">
        <pane-header
            :tools="tools"
            :hasBackButton="true"
            :title="`Loans - Borrower: ${ user.lastname }, ${ user.firstname } (${user.patron_group})`"
        />
        <ui-padding>
            <div class="loan-details__buttons">
                <ui-search-field class="loan-details__search-field" :tools="tools" />
                <span class="loan-details__results">12 results</span>
                <div class="loan-details__buttons__right-align">
                    <ui-button title="Renew" />
                    <ui-button title="Change due date" />
                    <ui-button title="Claim returned" />
                    <ui-button title="Lost" />
                    <ui-button title="Cancel loan" />
                </div>
            </div>
        </ui-padding>
        <ui-padding class="overflow-auto">
            <ui-data-list
                class="col-min-120"
                :hasCheckBox="true"
                preset="loan"
                type="results"
                :tools="tools"
                :maxItems="12"
                :minItems="3"
                :cache="true"
                :includeInList="{ user }"
                :dropdown="dropdownOptions"
            />
        </ui-padding>
        <pre>
            {{ /** JSON.stringify(currentView, null, 4) */ }}
        </pre>
    </div>
</template>

<script>
    export default {
        computed: {
            currentView() {
                return this.tools.currentView;
            },
            currentApp() {
                return this.tools.currentApp;
            },
            user() {
                return this.currentView.data.user;
            }
        },
        name: 'loans-view',
        props: ['tools', 'viewKey'],
        methods: {
            dropdownOptions(row) {
                const data = row.data;
                const { user } = this;
                return [
                    {
                        title: 'Loan details',
                        onClick: () => {
                            this.tools.changeView({
                                key: 'loan-details-view',
                                title: `Loan ${data.loan_id}`,
                                owner: 'users',
                                data: {
                                    ...data,
                                    includes: { user },
                                },
                            });
                        }
                    },
                    {
                        title: 'Claim returned',
                    },
                    {
                        title: 'Renew',
                    },
                    {
                        title: 'Change due date',
                    },
                    {
                        title: 'Change manual fee/fine',
                    },
                    {
                        title: 'Cancel loan',
                    },
                ];
            },
        },
    };
</script>

<style>
    .loan-details__search-field {
        width: 250px;
        margin-right: 12px;
    }
    .loan-details__results {
        color: rgba(0, 0, 0, .7);
        margin-right: 50px;
    }
    .loan-details__buttons__right-align {
        margin-left: auto;
        display: flex;
    }

    .loan-details__buttons {
        display: flex;
        align-items: center;
    }

    .loan-details__buttons button {
        margin-left: 6px;
    }
</style>



// WEBPACK FOOTER //
// LoansView.vue?b71a97a4